import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '@urc-ui/store/api/base';
import { HttpMethod, Tag } from '@urc-ui/store/api/types';
import { getLocaleheader, resolveAdvertisingApiBaseUrl } from '@urc-ui/store/api/ross/utils';
import { getFrbAuthorizationHeaders } from '@flexible-reports/store/api/base';
import { ReportEstimatesResponse } from '@flexible-reports/store/api/report-cost-estimation/api-types';
import {
  buildReportEstimatesRequest,
  ReportEstimatesRequestUI
} from '@flexible-reports/store/api/report-cost-estimation/transformers/transform-to-api-request';
import {
  ReportEstimatesResponseUI,
  transformFromAPIResponse
} from '@flexible-reports/store/api/report-cost-estimation/transformers/transform-from-api-response';

export const reportCostEstimationApi = createApi({
  reducerPath: 'reportCostEstimationApi',
  baseQuery: axiosBaseQuery({
    baseUrl: resolveAdvertisingApiBaseUrl()
  }),
  tagTypes: [Tag.REPORT_COST_ESTIMATION],
  endpoints: builder => ({
    retrieveReportEstimates: builder.query<ReportEstimatesResponseUI, ReportEstimatesRequestUI>({
      query: (request: ReportEstimatesRequestUI) => {
        const apiRequest = buildReportEstimatesRequest(request);
        return {
          url: '/adsApi/v1/retrieve/reportEstimates',
          method: HttpMethod.POST,
          headers: { ...getFrbAuthorizationHeaders(), ...getLocaleheader() },
          data: apiRequest
        };
      },
      transformResponse: (response: ReportEstimatesResponse): ReportEstimatesResponseUI => {
        return transformFromAPIResponse(response);
      }
    })
  })
});

export const { useLazyRetrieveReportEstimatesQuery } = reportCostEstimationApi;
